
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class OxyClassTokenNameInput extends Vue {
  @Prop()
  name!: string;

  @Prop()
  prefix?: string;

  nameToRename? = this.name;

  @Prop()
  invalid?: boolean;

  @Prop()
  errorMessage?: string;

  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.renameInput as HTMLElement;
      el.focus();

      const range = document.createRange();
      range.selectNodeContents(el);
      const sel = window.getSelection();

      sel?.removeAllRanges();
      sel?.addRange(range);
    });
  }
}
